import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-twq-loading-spinner',
    templateUrl: './twq-loading-spinner.component.html',
    styleUrls: ['./twq-loading-spinner.component.scss']
})
export class TwqLoadingSpinnerComponent {
    @Input() color?: string = '#4f008c';
}
